import { useState } from "react";
import Layouts from "../../Layouts";
import HimsModuleCards from "../NewDashboard/HimsModuleCards";
import { FaEye, FaSync, FaBed } from "react-icons/fa";
import { TbBed, TbBedOff, TbHeartRateMonitor, TbStethoscope } from "react-icons/tb";
import { MdOutlineBedroomChild } from "react-icons/md";

/* ─── Mock Data ─── */
const MOCK_PATIENTS = [
  {
    id: 1,
    name: "Rajesh Kumar",
    patientId: "DZP5641807",
    mobile: "+91 98765 43210",
    ageGender: "45 Y / Male",
    diagnosis: "Post-op Recovery",
    ward: "Ward A",
    bedNo: "A-01",
    admissionDate: "28/09/2026\n08:00 AM",
    doctor: "Dr. Karthik",
    doctorRole: "General Surgeon",
    status: "Stable",
    avatar: "R",
    avatarBg: "#EF4444",
  },
  {
    id: 2,
    name: "Sangeetha R",
    patientId: "DZP5641808",
    mobile: "+91 87654 32109",
    ageGender: "32 Y / Female",
    diagnosis: "Pneumonia",
    ward: "Ward B",
    bedNo: "B-03",
    admissionDate: "27/09/2026\n10:30 AM",
    doctor: "Dr. Priya",
    doctorRole: "Pulmonologist",
    status: "Critical",
    avatar: "S",
    avatarBg: "#6366F1",
  },
  {
    id: 3,
    name: "Murugan K",
    patientId: "DZP5641809",
    mobile: "+91 99887 76655",
    ageGender: "28 Y / Male",
    diagnosis: "Fracture",
    ward: "Ward A",
    bedNo: "A-04",
    admissionDate: "29/09/2026\n09:00 AM",
    doctor: "Dr. Anand",
    doctorRole: "Orthopedic Surgeon",
    status: "Stable",
    avatar: "M",
    avatarBg: "#8B5CF6",
  },
  {
    id: 4,
    name: "Lalitha M",
    patientId: "DZP5641810",
    mobile: "+91 91234 56789",
    ageGender: "60 Y / Female",
    diagnosis: "Diabetes Complication",
    ward: "Ward C",
    bedNo: "C-02",
    admissionDate: "26/09/2026\n11:00 AM",
    doctor: "Dr. Priya",
    doctorRole: "Endocrinologist",
    status: "Under Treatment",
    avatar: "L",
    avatarBg: "#22C55E",
  },
  {
    id: 5,
    name: "Kumaravel S",
    patientId: "DZP5641811",
    mobile: "+91 93456 78901",
    ageGender: "50 Y / Male",
    diagnosis: "Hypertension",
    ward: "Ward B",
    bedNo: "B-07",
    admissionDate: "29/09/2026\n07:30 AM",
    doctor: "Dr. Karthik",
    doctorRole: "Cardiologist",
    status: "Critical",
    avatar: "K",
    avatarBg: "#F59E0B",
  },
  {
    id: 6,
    name: "Meena D",
    patientId: "DZP5641812",
    mobile: "+91 94567 89012",
    ageGender: "38 Y / Female",
    diagnosis: "Post-surgical Care",
    ward: "Ward A",
    bedNo: "A-06",
    admissionDate: "28/09/2026\n02:00 PM",
    doctor: "Dr. Anand",
    doctorRole: "General Surgeon",
    status: "Discharge Ready",
    avatar: "M",
    avatarBg: "#14B8A6",
  },
];

const STATUS_STYLE = {
  Stable: "bg-green-50 text-green-700 border border-green-200",
  Critical: "bg-red-50 text-red-600 border border-red-200",
  "Under Treatment": "bg-amber-50 text-amber-700 border border-amber-200",
  "Discharge Ready": "bg-blue-50 text-blue-600 border border-blue-200",
};

const STAT_CARDS = [
  {
    label: "Total Inpatients",
    value: "28",
    pct: "4%",
    up: true,
    icon: <FaBed className="text-[#F59E0B] text-lg" />,
    iconBg: "#FEF3C7",
    chart: "amber",
  },
  {
    label: "Critical",
    value: "4",
    pct: "0%",
    up: false,
    icon: <TbHeartRateMonitor className="text-[#EF4444] text-lg" />,
    iconBg: "#FEE2E2",
    chart: "red",
  },
  {
    label: "Stable",
    value: "24",
    pct: "5%",
    up: true,
    icon: <TbStethoscope className="text-[#22C55E] text-lg" />,
    iconBg: "#DCFCE7",
    chart: "green",
  },
  {
    label: "Available Beds",
    value: "12",
    pct: "8%",
    up: true,
    icon: <TbBed className="text-[#6366F1] text-lg" />,
    iconBg: "#EDE9FE",
    chart: "indigo",
  },
];

const CHART_COLORS = {
  amber: ["#FDE68A", "#FCD34D", "#FBBF24", "#F59E0B", "#D97706"],
  red: ["#FECACA", "#FCA5A5", "#F87171", "#EF4444", "#DC2626"],
  green: ["#BBF7D0", "#86EFAC", "#4ADE80", "#22C55E", "#16A34A"],
  indigo: ["#C7D2FE", "#A5B4FC", "#818CF8", "#6366F1", "#4F46E5"],
};

const Sparkline = ({ color }) => (
  <div className="flex items-end gap-0.5 h-10">
    {(CHART_COLORS[color] || CHART_COLORS.amber).map((c, i) => (
      <div
        key={i}
        style={{
          backgroundColor: c,
          height: `${(i + 1) * 20}%`,
          width: "6px",
          borderRadius: "2px",
        }}
      />
    ))}
  </div>
);

export default function WardsPage() {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [wardFilter, setWardFilter] = useState("All");
  const [date, setDate] = useState("29/09/2026");

  const filtered = MOCK_PATIENTS.filter((p) => {
    const matchSearch =
      search === "" ||
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.patientId.toLowerCase().includes(search.toLowerCase()) ||
      p.mobile.includes(search);
    const matchStatus = statusFilter === "All" || p.status === statusFilter;
    const matchWard = wardFilter === "All" || p.ward === wardFilter;
    return matchSearch && matchStatus && matchWard;
  });

  return (
    <Layouts>
      <div className="p-4">
        {/* ── Common HIMS Module Cards ── */}
        <div className="mb-5">
          <HimsModuleCards activeId="wards" />
        </div>

        {/* ── Header ── */}
        <div className="flex items-center gap-4 mb-6">
          <div
            className="w-14 h-14 rounded-xl flex items-center justify-center"
            style={{ backgroundColor: "#FEF3C7" }}
          >
            <MdOutlineBedroomChild className="text-[#F59E0B] text-2xl" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-[#333333] font-sans">Wards</h1>
            <p className="text-sm text-gray-500 font-sans">
              Manage ward patients and bed allocation
            </p>
          </div>
        </div>

        {/* ── Stat Cards ── */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          {STAT_CARDS.map((card) => (
            <div
              key={card.label}
              className="bg-white border rounded-xl shadow-sm p-4 md:flex items-center justify-between"
            >
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: card.iconBg }}
                  >
                    {card.icon}
                  </div>
                  <p className="text-xs font-sans text-gray-500">{card.label}</p>
                </div>
                <div className="flex items-baseline gap-2">
                  <p className="text-2xl font-bold text-[#333333] font-sans">
                    {card.value}
                  </p>
                  <span
                    className={`text-xs font-sans ${
                      card.up ? "text-green-500" : "text-gray-400"
                    }`}
                  >
                    {card.up ? "↑" : ""} {card.pct}
                  </span>
                </div>
              </div>
              <Sparkline color={card.chart} />
            </div>
          ))}
        </div>

        {/* ── Filters ── */}
        <div className="bg-white border rounded-xl shadow-sm p-4 mb-4 flex flex-wrap gap-3 items-center">
          {/* Search */}
          <div className="flex items-center gap-2 border rounded-lg px-3 py-2 flex-1 min-w-[200px]">
            <svg
              className="text-gray-400 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="11" cy="11" r="8" strokeWidth="2" />
              <path
                d="M21 21l-4.35-4.35"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by patient name, ID, mobile number..."
              className="text-sm font-sans outline-none flex-1 bg-transparent text-gray-700 placeholder-gray-400"
            />
          </div>

          <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-3">
  {/* Status */}
  <div className="flex flex-col w-full sm:w-auto">
    <label className="text-[10px] font-sans text-gray-400 mb-1">
      Status
    </label>
    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      className="border rounded-lg px-3 py-2 text-sm font-sans text-gray-700 outline-none bg-white w-full"
    >
      {["All", "Stable", "Critical", "Under Treatment", "Discharge Ready"].map(
        (s) => (
          <option key={s}>{s}</option>
        )
      )}
    </select>
  </div>

  {/* Ward */}
  <div className="flex flex-col w-full sm:w-auto">
    <label className="text-[10px] font-sans text-gray-400 mb-1">
      Ward
    </label>
    <select
      value={wardFilter}
      onChange={(e) => setWardFilter(e.target.value)}
      className="border rounded-lg px-3 py-2 text-sm font-sans text-gray-700 outline-none bg-white w-full"
    >
      {["All", "Ward A", "Ward B", "Ward C"].map((w) => (
        <option key={w}>{w}</option>
      ))}
    </select>
  </div>

  {/* Date */}
  <div className="flex flex-col w-full sm:w-auto">
    <label className="text-[10px] font-sans text-gray-400 mb-1">
      Date
    </label>
    <div className="border rounded-lg px-3 py-2 flex items-center gap-2 w-full">
      <svg
        className="w-4 h-4 text-gray-400 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" strokeWidth="2" />
        <path
          d="M16 2v4M8 2v4M3 10h18"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <input
        type="text"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        className="text-sm font-sans outline-none bg-transparent text-gray-700 w-full sm:w-24"
      />
    </div>
  </div>

  {/* Actions */}
  <div className="flex items-end gap-2 w-full sm:w-auto">
    <button
      onClick={() => {
        setSearch("");
        setStatusFilter("All");
        setWardFilter("All");
      }}
      className="border rounded-lg p-2 text-gray-500 hover:bg-gray-50"
    >
      <FaSync className="w-4 h-4" />
    </button>
    <button
      onClick={() => {
        setSearch("");
        setStatusFilter("All");
        setWardFilter("All");
      }}
      className="border rounded-lg px-4 py-2 text-sm font-sans text-[#189FAA] font-semibold hover:bg-teal-50 flex-1 sm:flex-none"
    >
      Clear
    </button>
  </div>
</div>
        </div>

        {/* ── Table ── */}
        <div className="bg-white border rounded-xl shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm font-sans">
              <thead>
                <tr className="bg-gray-50 border-b">
                  {[
                    "#",
                    "Patient",
                    "Mobile Number",
                    "Age / Gender",
                    "Diagnosis",
                    "Ward",
                    "Bed No.",
                    "Admission Date",
                    "Doctor",
                    "Status",
                    "Actions",
                  ].map((h) => (
                    <th
                      key={h}
                      className="px-4 py-3 text-left text-xs font-semibold text-gray-500 whitespace-nowrap"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td
                      colSpan={11}
                      className="px-4 py-10 text-center text-gray-400 text-sm"
                    >
                      No ward patients found.
                    </td>
                  </tr>
                ) : (
                  filtered.map((p, idx) => (
                    <tr
                      key={p.id}
                      className="border-b hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-4 py-3 text-gray-500">{idx + 1}</td>

                      {/* Patient */}
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <div
                            className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
                            style={{ backgroundColor: p.avatarBg }}
                          >
                            {p.avatar}
                          </div>
                          <div>
                            <p className="font-semibold text-[#333333] text-xs">
                              {p.name}
                            </p>
                            <p className="text-[10px] text-gray-400">
                              {p.patientId}
                            </p>
                          </div>
                        </div>
                      </td>

                      <td className="px-4 py-3 text-gray-600 whitespace-nowrap">
                        {p.mobile}
                      </td>
                      <td className="px-4 py-3 text-gray-600 whitespace-nowrap">
                        {p.ageGender}
                      </td>
                      <td className="px-4 py-3 text-gray-600">{p.diagnosis}</td>
                      <td className="px-4 py-3 text-gray-600 font-medium">
                        {p.ward}
                      </td>
                      <td className="px-4 py-3 text-gray-600 font-medium">
                        {p.bedNo}
                      </td>
                      <td className="px-4 py-3 text-gray-600 whitespace-pre-line text-xs">
                        {p.admissionDate}
                      </td>

                      {/* Doctor */}
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <div className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-xs font-bold text-gray-600">
                            {p.doctor.charAt(3)}
                          </div>
                          <div>
                            <p className="text-xs font-semibold text-[#333333]">
                              {p.doctor}
                            </p>
                            <p className="text-[10px] text-gray-400">
                              {p.doctorRole}
                            </p>
                          </div>
                        </div>
                      </td>

                      {/* Status */}
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded-md text-xs font-semibold ${
                            STATUS_STYLE[p.status] ||
                            "bg-gray-100 text-gray-600"
                          }`}
                        >
                          {p.status}
                        </span>
                      </td>

                      {/* Actions */}
                      <td className="px-4 py-3">
                        <button className="text-[#189FAA] hover:text-teal-700">
                          <FaEye className="text-base" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ── Pagination ── */}
          <div className="px-4 py-3 border-t flex items-center justify-between">
            <p className="text-xs text-gray-400 font-sans">
              Showing 1 to {filtered.length} of {filtered.length} entries
            </p>
            <div className="flex items-center gap-2">
              <button className="px-3 py-1 border rounded-md text-xs text-gray-500 hover:bg-gray-50">
                ‹
              </button>
              <button className="px-3 py-1 rounded-md text-xs bg-teal-500 text-white">
                1
              </button>
              <button className="px-3 py-1 border rounded-md text-xs text-gray-500 hover:bg-gray-50">
                ›
              </button>
              <select className="border rounded-md px-2 py-1 text-xs text-gray-600 outline-none">
                <option>10 / page</option>
                <option>20 / page</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
}
